import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import config from 'utils/config';
import SimpleModal from 'components/SimpleModal';
import Text from 'components/Text';
import Stack from 'components/Stack';
import Heading from 'components/Heading';
import TrialWelcomeContent from 'screens/UserSkills/components/TrialWelcomeContent';
import { HelixChangeMyMindText, HelixEmailLink, HowHelixWorksText, SettingsLink } from 'screens/UserSkills';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var headingProps = {
  as: 'h2',
  size: 'small',
  mb: 's'
};
var stackProps = {
  spacing: 'xs',
  mb: 'l'
};
function HelixInfoModal(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(SimpleModal, {
    width: "extraWide",
    title: t('property_helix_info'),
    body: config.showTrialWelcomePage ? /*#__PURE__*/_jsx(TrialWelcomeContent, {
      withCards: false
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        size: "small",
        mb: "s",
        children: t('skills_empty_invite_helix_title')
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: "xs",
        mb: "l",
        children: [/*#__PURE__*/_jsxs(Trans, {
          i18nKey: "skills_empty_invite_helix_text_1",
          children: ["Ready to collect more data? Invite", /*#__PURE__*/_jsx(HelixEmailLink, {
            children: "helix@5app.com"
          }), "to your next meeting to get started!"]
        }), ['skills_empty_invite_helix_text_2', 'skills_empty_invite_helix_text_3'].map(function (key) {
          return /*#__PURE__*/_jsx(Text, {
            children: t(key)
          }, key);
        })]
      }), config.userCalendarIntegration && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h2",
          size: "small",
          mb: "s",
          children: t('skills_auto_join_title')
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: "xs",
          mb: "l",
          children: [/*#__PURE__*/_jsxs(Trans, {
            i18nKey: "skills_auto_join_text_1",
            children: ["You already know which meetings you\u2019d like Helix to attend? Via your", /*#__PURE__*/_jsx(SettingsLink, {
              children: "Settings"
            }), "page you can connect your calendar and choose which meetings Helix should automatically join in the future."]
          }), /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "skills_auto_join_text_2",
            children: ["No need to manually invite", /*#__PURE__*/_jsx(HelixEmailLink, {
              children: "helix@5app.com"
            }), "to the meeting - Helix will join based on your preferences."]
          }), /*#__PURE__*/_jsx(Text, {
            children: t('skills_auto_join_text_3')
          })]
        })]
      }), /*#__PURE__*/_jsx(HowHelixWorksText, {
        headingProps: headingProps,
        stackProps: stackProps
      }), /*#__PURE__*/_jsx(HelixChangeMyMindText, {
        headingProps: headingProps,
        stackProps: stackProps
      })]
    }),
    buttons: [{
      variant: 'primary',
      label: t('actions_close'),
      onClick: onClose
    }],
    onClose: onClose
  });
}
export default HelixInfoModal;